<template lang="pug">
the-mask(mask="#####-###" v-model.native="model")
</template>

<script>
import axios from 'axios'
const BASE_API_URL = 'https://viacep.com.br/ws'

export default {
  props: {
    value: { type: String, default: '' },
    ignoreFirst: { type: Boolean, default: false },
  },
  data() {
    return { loading: false, address: {}, isFirst: true }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        if (v.length === 8) {
          if (!this.ignoreFirst || !this.isFirst) this.findAddress(v)
          this.isFirst = false
        }
        this.$emit('input', v)
      },
    },
  },
  methods: {
    async findAddress(zipCode) {
      try {
        const { data } = await axios.get(`${BASE_API_URL}/${zipCode}/json`)
        if (data.erro) return this.$toaster.error('CEP não encontrado')
        this.$emit('zipcode-founded', {
          street: data.logradouro,
          city: data.localidade,
          neighborhood: data.bairro,
          complement: '',
          state: { code: data.uf },
        })
      } catch (e) {
        this.$toaster.error('Falha ao buscar cep')
      }
    },
  },
}
</script>
